import React from 'react';
import { Container } from 'react-bootstrap';
import HpAbout from './homepage/hpAbout';
import HpEventNotice from './homepage/hpEventNotice';
import HpDepartments from './homepage/hpDepartments';
import HpPrograms from './homepage/hpPrograms';
import HpCenters from './homepage/hpCenters';
import HpAwards from './homepage/hpAwards';
import HpCounters from './homepage/hpCounters';
import AdCounters from './admission/adCounters';
import PlacementCounters from './PlacementCounters'
import DynamicSlider from './DynamicSlider';
import HostalEventSlider from './HostalEventSlider';
import DepartmentLatest from './DepartmentLatest';
import DynamicMiscellaneousList from './DynamicMiscellaneousList';
import ResearchAwardees from './ResearchAwardees';
import AlumniGallery from './AlumniGallery';
import AlumniBytes from './AlumniBytes';
import AlumniMeet from './AlumniMeet';
import DswActivities from './DswActivities';
import DswSociety from './DswSociety';
import ConvocationMain from './ConvocationMain';
import ConvocationAward from './ConvocationAward';
import ConvocationGlimpses from './ConvocationGlimpses';
import ConvocationNews from './ConvocationNews';
import AlumniAll from './AlumniAll';
import AlumniSliders from './AlumniSliders';
import ResearchAwardAll from './ResearchAwardAll';
import ResearchGallery from './ResearchGallery';
import GlimpsesDetails from './GlimpsesDetails';


import DevPage from './DevPage';
const SectionStatic = ({ sp, sectionData,sdId }) => 
{
    if( global.config.IsPrint === true ) { console.info('sectionData : ',sectionData); }
    if(sectionData.ss_id === 3)
    {
        return <HpAbout />
    }
    else if(sectionData.ss_id === 4)
    {
        return <HpEventNotice />
    }
    else if(sectionData.ss_id === 5)
    {
        return <HpCounters />
    }
    else if(sectionData.ss_id === 6)
    {
        return <HpDepartments />
    }
    else if(sectionData.ss_id === 7)
    {
        return <HpPrograms />
    }
    else if(sectionData.ss_id === 8)
    {
        return <HpCenters />
    }
    else if(sectionData.ss_id === 9)
    {
        return <HpAwards />
    }
    else if(sectionData.ss_id === 11)
    {
        return <AdCounters />
    }
    else if(sectionData.ss_id === 13)
    {
        return <DynamicSlider stId={2} />
    }
    else if(sectionData.ss_id === 18)
    {
        return <PlacementCounters />
    }
    else if(sectionData.ss_id === 19)
    {
        return <DynamicSlider stId={4} />
    }
    else if(sectionData.ss_id === 20)
    {
        return <HostalEventSlider stId={5} />
    }
    else if(sectionData.ss_id === 22)
    {
        return <DepartmentLatest sdId={sdId} />
    }
    else if(sectionData.ss_id === 32)
    {
        return <ResearchAwardees sp={sp} />
    }
    else if(sectionData.ss_id === 33)
    {
        return <AlumniGallery sp={sp} />
    }
    else if(sectionData.ss_id === 36)
    {
        return <AlumniBytes sp={sp} />
    }
    else if(sectionData.ss_id === 37)
    {
        return <AlumniMeet />
    }
    else if(sectionData.ss_id === 38)
    {
        return <DswActivities sdId={10} />
    }
    else if(sectionData.ss_id === 39)
    {
        return <DswSociety sdId={2} />
    }
    else if(sectionData.ss_id === 40)
    {
        return <ConvocationMain sp={sp} />
    }
    else if(sectionData.ss_id === 42)
    {
        return <ConvocationAward sp={sp} />
    }
    else if(sectionData.ss_id === 43)
    {
        return <ConvocationGlimpses />
    }
    else if(sectionData.ss_id === 45)
    {
        return <ConvocationNews sp={sp} />
    }
    else if(sectionData.ss_id === 47)
    {
        return <AlumniAll />
    }
    else if(sectionData.ss_id === 49)
    {
        return <AlumniSliders />
    }
    else if(sectionData.ss_id === 50)
    {
        return <ResearchAwardAll />
    }
    else if(sectionData.ss_id === 52)
    {
        return <ResearchGallery />
    }
    else if(sectionData.ss_id === 54)
    {
        return (
            <Container>
                <DynamicMiscellaneousList mtId={36} textClass="text-normal" />
            </Container>
        );
    }
    else if(sectionData.ss_id === 56)
    {
        return (
            <Container className='mb-4'>
                <GlimpsesDetails htaccess="university-administration-glimpses" />
            </Container>
        );
    }
    else
    {
        return <DevPage />
    }
}
export default SectionStatic;